export const LABEL = 'featured';
